/* eslint-disable react/jsx-indent */
import * as React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import { Zoom } from "react-awesome-reveal";
import Link from "next/link";
import AgapeSlider from "../../../../common/slider/AgapeSlider";
import { limit } from "../../../../../helpers/stringLimit";
import ProjectCard from "../../../../common/card/ProjectCard";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    marginTop: 60,
    [theme.breakpoints.down("md")]: {
      marginTop: 40,
      padding: 10,
    },
  },
  div: {
    direction: "ltr",
    padding: 10,
  },
  title: {
    fontWeight: "bold",
    fontSize: "18px",
    color: "#292929",
    marginBottom: "-20px",
  },
  title2: {
    fontWeight: "bold",
    fontSize: "16px",
    color: "#009693",
    textAlign: "right",
    zIndex: "9999",
  },
}));

const Projects = ({ projects = [] }) => {
  const classes = useStyles();

  return (
    <Zoom triggerOnce delay={1000}>
      <Grid container className={classes.container} alignItems="center">
        <Grid item xs={8} md={4}>
          <Typography variant="h2" className={classes.title}>
            پروژه های نیکوکاری
          </Typography>
        </Grid>
        {projects.length > 0 && (
          <Grid item xs={12}>
            <AgapeSlider
              listLength={projects.length}
              slidesToShowDesktop={3}
              slidesToShowTablet={2}
              slidesToShowMobile={1}
              arrow
              autoplay
              infinite
              // dots
            >
              {projects.map((item) => (
                <div className={classes.div} key={item.id}>
                  <ProjectCard
                    image={item.banner}
                    title={item.name}
                    subtitle={limit(item.subtitle, 90)}
                    slug={item.slug}
                    type={item.type}
                  />
                </div>
              ))}
            </AgapeSlider>
          </Grid>
        )}
      </Grid>
    </Zoom>
  );
};

export default Projects;
